import React from "react";

export const formatPriceStyle = (price,disableStyle=false) => {

    if(!price) return null;

    price = price.toString();

    const priceParts = price.split('.');
    const priceInt = priceParts[0];
    const priceDec = priceParts[1];
    return <span className={!disableStyle ? 'text-lg lg:text-2xl' : undefined}>{priceInt},<span className={!disableStyle ? 'text-sm lg:text-lg' : undefined}>{priceDec}</span></span>
}
export const formatCurrencySymbol = (currency) => {
    if (currency === 'EUR') {
        return '€';
    } else if (currency === 'USD') {
        return '$';
    } else if (currency === 'GBP') {
        return '£';
    } else if (currency === 'AUD') {
        return 'A$';
    }

    return currency;
}

export const roundPrice = (numStr, decimals = 2) => {
    const num = parseFloat(numStr);

    if (isNaN(num)) {
        // Gestisci l'input non numerico come preferisci
        // Potresti restituire NaN, la stringa originale, 0, o lanciare un errore
        return NaN;
    }

    // Epsilon per mitigare le imprecisioni dei numeri in virgola mobile
    // vicino ai punti di arrotondamento (es. 2.555 potrebbe essere 2.554999...).
    // L'epsilon spinge questi numeri dalla parte corretta per l'arrotondamento.
    // Deve essere piccolo per non influenzare numeri non vicini a x.5.
    // Il segno dell'epsilon deve corrispondere al segno del numero.
    const epsilon = Math.sign(num) * 1e-9; // 1e-9 è una scelta comune e sicura

    const factor = Math.pow(10, decimals);

    // Numero da arrotondare, dopo l'aggiustamento con epsilon e la scalatura
    const numToRoundScaled = (num + epsilon) * factor;

    // Logica per "round half away from zero":
    // 1. Prendi il valore assoluto del numero scalato.
    // 2. Arrotonda all'intero più vicino (Math.round() arrotonda .5 verso +infinito).
    // 3. Riapplica il segno originale del numero (o di num + epsilon).
    // 4. Dividi per il fattore di scala.
    const roundedAbsoluteScaled = Math.round(Math.abs(numToRoundScaled));

    // Math.sign(num) gestisce correttamente anche lo zero.
    // Se num è 0, epsilon è 0, numToRoundScaled è 0, roundedAbsoluteScaled è 0.
    // Math.sign(0) * 0 / factor = 0.
    const result = Math.sign(num + epsilon) * roundedAbsoluteScaled / factor;

    // Per evitare -0, anche se matematicamente corretto, potresti fare:
    // return result === 0 ? 0 : result;
    return result;
}